import { keyBy } from "@adsk/alloy-react-helpers";

import {
  AssetDTO,
  AssetWithCategoryAndStatus,
  CategoryDTO,
  parseAsset,
  parseCategory,
  parseStatus,
  StatusDTO,
  StatusSetAssignment,
} from "../../models";

const getParsedAssets = (
  assets: AssetDTO[],
  categories: CategoryDTO[],
  statuses: StatusDTO[],
  statusSetAssignments?: StatusSetAssignment[]
): AssetWithCategoryAndStatus[] => {
  const categoriesMap = keyBy(categories, "internalId");
  const statusesMap = keyBy(statuses, "id");
  const statusSetByCategory = keyBy(statusSetAssignments || [], "categoryId");

  return assets.map((asset) => {
    const category = categoriesMap[asset.categoryId];
    const status = statusesMap[asset.statusId];
    const statusSetAssignment = statusSetByCategory[category?.internalId || ""];

    return {
      ...parseAsset(asset),
      ...(category && {
        category: parseCategory({
          ...category,
          statusSetAssignment,
        }),
      }),
      ...(status && { status: parseStatus(status) }),
    };
  });
};

export default getParsedAssets;
